export default (params) => ({
  trigger: {
    name: 'content_blocks.text_image_video.view',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'text',
          'text_and_image',
          'text_and_image_two_column',
          'text_and_image_three_column',
          'text_and_video',
          'video',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
      params: {
        content: null,
      },
    },
    nonInt: true,
  },
});
